import { render, staticRenderFns } from "./OneQuantityAndIntervalInfo.vue?vue&type=template&id=1a0a2cf0&scoped=true&"
import script from "./OneQuantityAndIntervalInfo.vue?vue&type=script&lang=ts&"
export * from "./OneQuantityAndIntervalInfo.vue?vue&type=script&lang=ts&"
import style0 from "./OneQuantityAndIntervalInfo.vue?vue&type=style&index=0&id=1a0a2cf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.8_css-loader@4.3.0_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0a2cf0",
  null
  
)

export default component.exports